import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import InfoPanel from '@hobs/components/InfoPanel';
import InputLabel from '@hobs/components/InputLabel';
import File from '@hobs/components/File';
import FieldHistoryMessage from '@hobs/components/FieldHistoryMessage';
import ShortId from 'shortid';

import './CatalogItemInfo.scss';
import Money from '../Money';

const CatalogItemInfo = ({
  title,
  description,
  rateFrom,
  rateTo,
  attachments,
  groupName,
  annexName,
  currency,
  uom,
  t,
  categoryServiceRequests,
  partyId,
  editedFields = [],
  annexinformation,
  tooltipStartDisabled,
  catalogItemId
}) => {
  return (
    <div>
      <InfoPanel
        title={title}
        titleIndicationMessage={FieldHistoryMessage(
          'ServiceName',
          editedFields
        )}
        detailsIndicationMessage={FieldHistoryMessage(
          'ServiceDescription',
          editedFields
        )}
        toolTipInformation={annexinformation}
        tooltipStartDisabled={tooltipStartDisabled}
        catalogItemId={catalogItemId}
      >
        {description}
      </InfoPanel>
      <div className="catalog-item-info--item-data">
        <div className="catalog-item-info--small-data-row">
          <InputLabel
            indicationMessage={FieldHistoryMessage(
              'ItemPriceFrom',
              editedFields,
              ['ItemPriceTo']
            )}
          >
            {t('Item price')}:
          </InputLabel>
          <span>
            <Money amount={rateFrom} /> - <Money amount={rateTo} />{' '}
            {t(`${currency} per ${uom}`)}
          </span>
        </div>
        <div className="catalog-item-info--small-data-row catalog-item-info--files">
          <InputLabel>{t('Files')}:</InputLabel>
          {attachments && attachments.length > 0 ? (
            attachments.map(file => (
              <File
                key={ShortId.generate()}
                name={file.name}
                attachmentId={file.attachmentId}
              />
            ))
          ) : (
            <span>-</span>
          )}
        </div>
        <div className="catalog-item-info--small-data-row">
          <InputLabel
            indicationMessage={FieldHistoryMessage('GroupName', editedFields)}
          >
            {t('Group')}:
          </InputLabel>
          <span>{groupName}</span>
        </div>
        <div className="catalog-item-info--small-data-row">
          <InputLabel
            indicationMessage={FieldHistoryMessage('AnnexName', editedFields)}
          >
            {t('Annex')}
          </InputLabel>
          <span>{annexName}</span>
        </div>
      </div>
      {categoryServiceRequests && categoryServiceRequests.length > 0 && (
        <div className="catalog-item-info--item-data">
          <div className="catalog-item-info--small-data-row">
            <InputLabel>{t('Split to')}:</InputLabel>
            <span>
              {categoryServiceRequests.map(item => {
                return (
                  <div key={item.serviceRequestId}>
                    <Link
                      to={
                        partyId
                          ? `/service-request/${partyId}/${item.serviceRequestId}`
                          : `/service-request/${item.serviceRequestId}`
                      }
                      title={item.name}
                    >
                      {item.name}
                    </Link>
                  </div>
                );
              })}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

CatalogItemInfo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  rateFrom: PropTypes.number,
  rateTo: PropTypes.number,
  attachments: PropTypes.array,
  categoryServiceRequests: PropTypes.array,
  groupName: PropTypes.string,
  annexName: PropTypes.string,
  currency: PropTypes.string,
  uom: PropTypes.string,
  partyId: PropTypes.string,
  t: PropTypes.func,
  editedFields: PropTypes.array,
  annexinformation: PropTypes.string,
  tooltipStartDisabled: PropTypes.bool,
  catalogItemId: PropTypes.string
};

export default withTranslation()(CatalogItemInfo);
